<script setup lang="ts">
defineOptions({ inheritAttrs: false });
</script>
<template>
  <nut-empty v-bind="$attrs">
    <template #image v-if="$slots.image"><slot name="image" /></template>
    <template #default v-if="$slots.default"> <slot name="default" /></template>
    <template #description v-if="$slots.description">
      <slot name="description" />
    </template>
  </nut-empty>
</template>
